class SlideshowVideoLoader extends HTMLElement {
  constructor() {
    super();
    this.desktopQuery = window.matchMedia("(min-width: 768px)");
    this.loadVideos = this.loadVideos.bind(this);
  }

  connectedCallback() {
    this.showSurfaceWrapper();
    this.loadVideos();
    this.desktopQuery.addEventListener("change", this.loadVideos);
  }

  disconnectedCallback() {
    this.desktopQuery.removeEventListener("change", this.loadVideos);
  }

  isMobileLoader() {
    return this.dataset.device === "mobile" || this.classList.contains("mobile-video-loader-container");
  }

  loadVideos() {
    const isMobile = !this.desktopQuery.matches;
    const isMobileLoader = this.isMobileLoader();

    // Only load mobile videos on mobile, and desktop videos on desktop
    if (isMobileLoader && !isMobile) return;
    if (!isMobileLoader && isMobile) return;

    this.showSurfaceWrapper();

    const templateSelector = isMobileLoader ? ".mobile-video-template" : ".desktop-video-template";
    const wrapperSelector = isMobileLoader ? ".mobile-video-wrapper" : ".desktop-video-wrapper";
    const posterSelector = isMobileLoader ? ".mobile-video-poster" : ".desktop-video-poster";

    const templates = this.querySelectorAll(templateSelector);

    templates.forEach((tmpl) => {
      if (tmpl.dataset.loaded === "true") return;

      const posterWrapper = tmpl.previousElementSibling;
      const poster = posterWrapper?.querySelector(posterSelector);
      const playBtn = posterWrapper?.querySelector(".video-play-btn");

      // Get video wrapper + template
      const targetWrapper = tmpl.content.querySelector(wrapperSelector);
      const templateEl = tmpl.content.querySelector("[data-video-template]");
      const videoHTML = templateEl?.innerHTML.trim();

      if (!targetWrapper || !templateEl || !videoHTML) return;

      const hasVisiblePlayBtn = playBtn && playBtn.style.display !== "none" && getComputedStyle(playBtn).display !== "none";

      if (!poster || !hasVisiblePlayBtn) {
        this.showSurfaceWrapper();
        targetWrapper.innerHTML = videoHTML;

        if (posterWrapper) {
          posterWrapper.replaceWith(targetWrapper);
        } else {
          tmpl.insertAdjacentElement("afterend", targetWrapper);
        }
        this.autoPlayInsertedVideo(targetWrapper);

        tmpl.dataset.loaded = "true";

        this.dispatchEvent(
          new CustomEvent("slideshow:video-loaded", {
            bubbles: true,
            detail: { wrapper: targetWrapper }
          })
        );
        return;
      }

      playBtn.addEventListener(
        "click",
        () => {
          poster.classList.add("fade-out");

          setTimeout(() => {
            this.showSurfaceWrapper();
            posterWrapper.replaceWith(targetWrapper);
            targetWrapper.innerHTML = videoHTML;
            this.autoPlayInsertedVideo(targetWrapper);
            tmpl.dataset.loaded = "true";

            this.dispatchEvent(
              new CustomEvent("slideshow:video-loaded", {
                bubbles: true,
                detail: { wrapper: targetWrapper }
              })
            );
          }, 350);
        },
        { once: true }
      );
    });
  }

  showSurfaceWrapper() {
    const surfaceWrapper = this.closest(".surface-wrapper");
    if (surfaceWrapper) {
      surfaceWrapper.style.display = "block";
    }
  }

  autoPlayInsertedVideo(wrapper) {
    const videoTag = wrapper.querySelector("video");
    const videoMedia = wrapper.querySelector("video-media");

    if (videoTag) {
      videoTag.playsInline = true;
      videoTag.muted = true;
      videoTag
        .play()
        .then(() => {
          if (videoMedia) videoMedia.setAttribute("playing", "");
        })
        .catch(() => {});
    } else if (videoMedia) {
      videoMedia.play?.();
    }
  }
}

if (!customElements.get("slideshow-video-loader")) {
  customElements.define("slideshow-video-loader", SlideshowVideoLoader);
}